module.exports = __webpack_public_path__ + "static/media/winhlp32_4001.6204f3e4.ico";